<nav class="head-nav">
    <div class="nav-container">
        <div>
            <h2>{{ "restaurant.Cancellation & Refund Policies" | translate }}</h2>
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
                </li>
                <li class="breadcrumb-item" *ngIf="restaurantId">
                    <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
                </li>
                <li class="breadcrumb-item">{{"restaurant.Cancellation & Refund Policies" | translate}}</li>
            </ol>
        </div>
        <app-restaurants-dropdown (all)="GetScreenData($event)"></app-restaurants-dropdown>
    </div>
</nav>


<div class="page">
    <ng-container *ngIf='!dataLoading'>
        <div class="page-filters mb-3">
            <div class="sort-item">
                <span class="count-page font-16">
                    <span>{{recordsData?.cancellationPolicies?.totalCount}}</span>
                    {{'content4.Cancellation Policies' | translate}}
                </span>
            </div>
          
            <a class="btn-light d-flex ml-auto" mat-stroked-button (click)="addCancellationPolicy(null)"
                *ngIf="recordsData?.canAdd">
                <img src="./assets/images/icons/plus-ic.svg">
                <span>{{"availabilty.Add New" | translate}}</span>
            </a>
        </div>
        <div class="info font-14 mt-5 mb-5">
            <p>{{"restaurant.Cancellation Hint" | translate}}</p>
            <p>{{"restaurant.Cancellation info" | translate}}</p>
        </div>
        <!-- Cancellation Table -->
        <div
            *ngIf="recordsData?.cancellationPolicies?.pageData && recordsData?.cancellationPolicies?.pageData?.length; else dataEmpty">
            <!-- *ngIf="recordsData?.cancellationPolicies?.pageData && recordsData?.cancellationPolicies?.pageData?.length; else dataEmpty" -->
            <div class="table-responsive table-container">
                <table class="table table-primary table-hover no-background">
                    <thead>
                        <tr style="background-color: transparent !important;">
                            <th>{{'restaurant.Policy Title' | translate}}</th>
                            <th>{{'restaurant.Refund Amount' | translate}}</th>
                            <th>{{'restaurant.Before Booked Reservation Time by' | translate}}</th>
                            <!-- <th>{{'restaurant.After Guest Submit Reservation by' | translate}}</th> -->
                            <th></th>
                        </tr>

                    </thead>
                    <tbody>
                        <tr *ngFor="let item of recordsData?.cancellationPolicies?.pageData">
                            <td class="font-14 fontMedium">{{item.name}}</td>
                            <td class="font-14 fontMedium">{{item.refundAmount}}%</td>
                            <td class="font-14 fontMedium">{{item.beforeReservation}}</td>
                            <!-- <td class="font-14 fontMedium">{{item.afterReservation}}</td> -->
                            <td>
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button *ngIf="item.isActive && recordsData?.canEdit"
                                        (click)="changeCancellationPolicyStatus(item.id, false)"
                                        [matTooltip]="'general.Deactivate' | translate">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button *ngIf="!item.isActive && recordsData?.canEdit"
                                        (click)="changeCancellationPolicyStatus(item.id, true)"
                                        [matTooltip]="'general.Activate' | translate">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        (click)="addCancellationPolicy(item.id)" *ngIf="recordsData?.canEdit">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Delete' | translate"
                                        (click)="deleteCancellationRecord(item.id)" *ngIf="recordsData?.canDelete">
                                        <mat-icon class="delete-icon">delete</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div class="pagination-container mt-3 mb-4"
                *ngIf="recordsData && (pageCount > 1 || recordsData?.cancellationPolicies!.totalCount > pageSize)">
                <mat-paginator [length]="recordsData.cancellationPolicies!.totalCount" [pageSize]="filterModel.pageSize"
                    [pageSizeOptions]="[4, 8, 12]" (page)="getAllCancellation($event, restaurantId)" [pageIndex]="filterModel.pageNumber">
                </mat-paginator>
            </div>
        </div>
        <ng-template #dataEmpty>
            <empty-state [title]='"restaurant.Cancellation and refund policies not yet added" | translate'
                [img]="'/assets/images/icons/cancellation_refund_illustration.svg'"></empty-state>
        </ng-template>

        <!-- No Show Policy Card -->
        <div class="mt-3">
            <div class="card card-with-no-border">
                <div class="card-content mt-3">
                    <div class="title font-20 fontMedium">
                        {{'restaurant.No-Show Policy' | translate}}
                        <p class="info mt-5 font-14">
                            {{"restaurant.This policy will be applied once the restaurants host or those who have his permission take a reservation with a No Show action" | translate}}
                        </p>
                    </div>

                    <div class="grey-list-items form-group mt-3">
                        <div class="list-item mt-1">
                            <div class="d-flex align-items-center">
                                <p class="font-14 fontRegular grey-color">{{'restaurant.Refund Amount' | translate }}: </p>
                                <span class="font-14 ml-3 fontMedium">{{policyAmount + '%'}}</span>
                            </div>
                            <div class="mr-2">
                                <div class="btn-actions">
                                  <ng-container *ngIf="recordsData?.noShowPolicies">
                                    <button type="button" mat-icon-button
                                        *ngIf="recordsData?.noShowPolicies?.isActive && recordsData?.canEdit"
                                        (click)="changeShowPolicyStatus(0, false)"
                                        [matTooltip]="'general.Deactivate' | translate">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button
                                        *ngIf="!recordsData?.noShowPolicies?.isActive && recordsData?.canEdit"
                                        (click)="changeShowPolicyStatus(0, true)"
                                        [matTooltip]="'general.Activate' | translate">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                  </ng-container>
                                  <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                      (click)="editShowPolicy(policyAmount)" *ngIf="recordsData?.canEdit">
                                      <mat-icon>edit</mat-icon>
                                  </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Exception Card -->
        <div class="mt-3">
            <div class="card card-with-no-border">
                <div class="card-content mt-3">
                    <div class="title font-20 fontMedium">
                        {{'restaurant.Exceptions' | translate}}
                        <p class="info mt-5 mb-4">
                            {{"restaurant.Exceptions mean that certain guests are not charged cancellation fees and are fully refunded" | translate}}
                        </p>
                    </div>
                    <div class="grey-list-items form-group">
                        <div class="list-item pb-0">
                            <div class="d-flex align-items-center">
                                <p class="font-14 fontRegular grey-color">{{'restaurant.Guests who booked this no. of reservations (all the time)' | translate }}: </p> <span
                                    class="font-14 ml-3 fontMedium">{{exceptionReservationNumber?.reservationNumber}}</span>
                            </div>
                            <div class="mr-2">
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button
                                        *ngIf="recordsData?.exception?.isActive && recordsData?.canEdit"
                                        (click)="changeExceptionReservationStatus(false)"
                                        [matTooltip]="'general.Deactivate' | translate">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button
                                        *ngIf="!recordsData?.exception?.isActive && recordsData?.canEdit"
                                        (click)="changeExceptionReservationStatus(true)"
                                        [matTooltip]="'general.Activate' | translate">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        *ngIf="recordsData?.canEdit"
                                        (click)="exceptionRuleForReservation(exceptionReservationNumber?.reservationNumber)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="list-item mt-3 pt-0">
                            <div class="d-flex align-items-center">
                                <p class="font-14 fontRegular grey-color pr-3">{{'restaurant.Guests who got these tags' |
                                    translate }}: </p>
                                <ng-container *ngIf="exceptionTags">
                                    <span *ngFor="let selectedTag of exceptionTags.selectedTags; let last = last">
                                        <ng-container *ngFor="let tag of exceptionTags.allTags">
                                            <span class="font-14 fontMedium"
                                                *ngIf="selectedTag == tag.id">{{tag.name}}<span *ngIf="!last">,
                                                </span>
                                            </span>
                                        </ng-container>
                                    </span>
                                </ng-container>
                            </div>
                            <div class="mr-2">
                                <div class="btn-actions">
                                    <button type="button" mat-icon-button
                                        *ngIf="exceptionTags?.selectedTags && recordsData?.exceptionTags?.isActive && recordsData?.canEdit"
                                        (click)="changeExceptionTagStatus(false)"
                                        [matTooltip]="'general.Deactivate' | translate">
                                        <mat-icon>pause</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button
                                        *ngIf="exceptionTags?.selectedTags && !recordsData?.exceptionTags?.isActive && recordsData?.canEdit"
                                        (click)="changeExceptionTagStatus(true)"
                                        [matTooltip]="'general.Activate' | translate">
                                        <mat-icon>play_arrow</mat-icon>
                                    </button>
                                    <button type="button" mat-icon-button [matTooltip]="'general.Edit' | translate"
                                        *ngIf="recordsData?.canEdit" (click)="exceptionRuleForGuestsTags()">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div *ngIf='dataLoading' class="dataLoading py-5">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
    </div>
</div>
